import styles from "../style/projectImage.module.css"

const ProjectImage: React.FC<{ imageUrl: string }> = ({ imageUrl }) => {
  return (
    <div className={styles.projectImageContainer}>
      <img
        alt="The image has not been uploaded from Amazon yet"
        src={imageUrl}
        className={styles.projectImage}
      />
    </div>
  )
}

export default ProjectImage
